import { Redirect } from 'react-router-dom';

import RoutesByLayout from '../components/routes/RoutesByLayout';
import { PathsLayouts } from '../config/routes';
import { useUserState } from '../hooks/useUserState';

const AuthLayout = () => {
  const { isLogged, userData } = useUserState();

  if (isLogged) {
    // Non-regular students can only access petitions
    if (userData?.isRegular === false) {
      return <Redirect to={PathsLayouts.petitions} />;
    }
    return <Redirect to={PathsLayouts.studentManagement} />;
  }
  return (
    <>
      <RoutesByLayout pathLayout={PathsLayouts.auth} />
    </>
  );
};

export default AuthLayout;
